"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.withEmptyStateFallback = exports.Element = exports.Editor = exports.markHtmlElements = exports.MarkType = exports.ElementType = exports.ActionType = exports.modKey = void 0;
var slate_1 = require("slate");
var systemUtilities_1 = require("../../../util/systemUtilities");
exports.modKey = systemUtilities_1.isMac ? 'Cmd' : 'Ctrl';
var ActionType;
(function (ActionType) {
    ActionType["Redo"] = "redo";
    ActionType["Undo"] = "undo";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var ElementType;
(function (ElementType) {
    ElementType["BulletedList"] = "bulleted-list";
    ElementType["Headline"] = "headline";
    ElementType["Link"] = "link";
    ElementType["ListItem"] = "list-item";
    ElementType["NumberedList"] = "numbered-list";
    ElementType["Paragraph"] = "paragraph";
    ElementType["SubHeadline"] = "sub-headline";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
var MarkType;
(function (MarkType) {
    MarkType["Bold"] = "bold";
    MarkType["Italic"] = "italic";
    MarkType["StrikeThrough"] = "strike-through";
    MarkType["Underline"] = "underline";
})(MarkType = exports.MarkType || (exports.MarkType = {}));
exports.markHtmlElements = (_a = {},
    _a[MarkType.Bold] = 'strong',
    _a[MarkType.Italic] = 'em',
    _a[MarkType.StrikeThrough] = 's',
    _a[MarkType.Underline] = 'u',
    _a);
var CustomEditor = slate_1.Editor;
exports.Editor = CustomEditor;
var CustomElement = slate_1.Element;
exports.Element = CustomElement;
function withEmptyStateFallback(state) {
    return (state || [
        {
            type: ElementType.Paragraph,
            children: [{ text: '' }],
        },
    ]);
}
exports.withEmptyStateFallback = withEmptyStateFallback;
